import { z } from 'zod';
import { providerSlugSchema } from './credential.js';
export const usageQuerySchema = z.object({
    credentialId: z.string().uuid().optional(),
    customerId: z.string().uuid().optional(),
    providerSlug: providerSlugSchema.optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
});
export const usageRefreshQuerySchema = z.object({
    customerId: z.string().uuid().optional(),
    providerSlug: providerSlugSchema.optional(),
});
